module.exports = __webpack_public_path__ + "static/media/waiting.3f349766.gif";